import * as CookieHelper from '../helpers/CookieHelper';
import * as axios from './axiosRequests';
import jwt from 'jsonwebtoken';
import { environment } from '../../config/appEnvironment';

const { REACT_APP_STNE_AUTH } = environment;

export const getPublicUrl = () => {
  return `${window.location.origin}`;
};

export const getStneOauthSalesforceToken = async code => {
  const url = `${REACT_APP_STNE_AUTH}/api/oauth/salesforce/token`;
  const { data } = await axios.runPostRequest(url, { code, redirectUri: redirectUriCb });

  const { id: idResponse, id_token, access_token, refresh_token } = data;
  const { exp } = jwt.decode(id_token); // exp configured on connected app
  const myUserId = idResponse.match(/\w+$/)[0];

  const HOURS_IN_MINUTES = 11 * 60; // 11h
  const MINUTES_IN_SECONDS = HOURS_IN_MINUTES * 60;

  CookieHelper.setCookie('new_ssid', access_token, exp, 'timestamp');
  CookieHelper.setCookie('rfTk', refresh_token, exp + MINUTES_IN_SECONDS, 'timestamp');
  CookieHelper.setCookie('userId', myUserId, exp + MINUTES_IN_SECONDS, 'timestamp');
  localStorage.setItem('userId', myUserId); // later removed
};

export const getStneOauthSalesforceConfigurations = async () => {
  const url = `${REACT_APP_STNE_AUTH}/api/oauth/salesforce/configurations`;
  return await axios.runGetRequest(url);
};

export const getStneRefreshedToken = async () => {
  const url = `${REACT_APP_STNE_AUTH}/api/oauth/salesforce/refresh`;
  const rfTk = CookieHelper.getCookie('rfTk');

  const { data } = await axios.runPostRequest(url, { rfTk });
  const { id_token, access_token } = data;
  const { exp } = jwt.decode(id_token);

  CookieHelper.removeCookie('new_ssid');
  CookieHelper.setCookie('new_ssid', access_token, exp, 'timestamp');
};

export const revokeStneToken = async () => {
  const url = `${REACT_APP_STNE_AUTH}/api/oauth/salesforce/revoke`;
  const token = CookieHelper.getCookie('new_ssid');
  return await axios.runPostRequest(url, { token });
};

export const redirectUriCb = `${getPublicUrl()}/oauth/salesforce/cb`;
export const redirectUri = `${getPublicUrl()}/oauth/salesforce/callback`;
export const homeRoute = '/polar';
